export default "__VITE_ASSET__bb92ea43__"